import { useHttp, useTranslate } from '@/shared/lib'
import { useMutation, useQuery } from '@tanstack/vue-query'
import type { Ref } from 'vue'
import { useNotification } from '@/shared/ui'

/**
 * Функция загрузки списка координат объекта
 */
export const useLoadObjectCoords = (objectId: number, active: Ref<boolean>) => {
  const http = useHttp()

  return useQuery({
    queryKey: ['load_object_coords', objectId],
    queryFn: () => http.get(`/objects/${objectId}/coordinates`),
    retry: false,
    enabled: active,
  })
}

/**
 * Функция отправки новых координат объекту
 */
export const useSendObjectCoords = () => {
  const http = useHttp()
  const { addError } = useNotification()
  const { trs } = useTranslate()

  const mutation = useMutation({
    mutationFn: (data: any) => {
      return http.put(`/objects/${data.object_id}/coordinates`, data)
    },
  })

  const save = async (objectId: number, coords: any) => {
    try {
      return await mutation.mutateAsync({
        object_id: objectId,
        coordinates: coords,
      })
    } catch (error: any) {
      addError(trs(error?.response?.data?.data?.msg || 'request.unknown_error'))
    }
  }

  return {
    ...mutation,

    save,
  }
}
